import React from 'react';
import PropTypes from 'prop-types';
import gravatar from 'gravatar';
import ColorHash from 'color-hash';
import Component from 'BaseComponent';

export default class Avatar extends Component {

  static propTypes = {
    account: PropTypes.object.isRequired,
    size: PropTypes.number.isRequired,
  };

  render() {
    const { account, size } = this.props;

    if (!account) {
      return <div className="Avatar" style={{ width: size, height: size }} />;
    }

    const initials = account.attributes.name.trim().split(/ +/).reduce((acc, w) => acc + w[0].toUpperCase(), '');
    const gravatarUrl = gravatar.url(account.attributes.email, { s: size, d: 'blank' });
    const colorHash = new ColorHash({ lightness: 0.5 }).hex(name);

    const style = {
      backgroundColor: colorHash,
      width: size,
      height: size,
      lineHeight: `${size - 4}px`,
      fontSize: `${Math.round(size * 0.5)}px`,
    };

    return (
      <div className="Avatar" style={style}>
        {initials.toUpperCase()}
        <img src={gravatarUrl} alt={name} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Avatar.jsx